import { useState, useEffect, useRef } from 'react';
import { CloseRounded } from '@mui/icons-material';
import Thumbnail from '../../components/thumbnail';
import SpinLoader from '../../components/spin-loader';
import axios from 'axios';
import 'stream-engine-player/bundle';
import 'stream-engine-player/style';

import { API_URL } from '../../utils/consts';

const PlayerWidget = ({ data, apiUrl}) => {
  const [item, setItem] = useState();
  const playerRef = useRef();
  const [playerPos, setPlayerPos] = useState();
  const [floating, setFloating] = useState();

  useEffect( () => {
    const item = data.content[0];
    setItem(item);

    const fetchData = async () => {
      try {
        const { id: token } = data;
        const { id: itemId } = item;
        const { data: widget } = await axios.get(
          `${apiUrl || API_URL}/widgets/${token}?filter_by=${itemId}`
        );

        const { name } = widget;
        const input = widget?.content[0];
        const {
          id,
          src,
          state,
          type,
          name: videoTitle,
          tags,
          organizations,
          parent,
          recording_id,
          external_id,
          ad
        } = input;

        const { logo, playback_control, style } = widget?.player;
        const { position } = logo;
        const { skip_back_enable, skip_forward_enable, controls } =
          playback_control;
        const { url: logoSrc } = widget?.settings?.defaultThumbnail;
        const {
          id: workspaceId,
          name: workspaceName,
          token: workspaceToken,
          owner: workspaceOwner,
        } = organizations[0];
        const { url: adTagUrl } = ad

        const playerProps = {
          src,
          logoSrc,
          controls,
          logoPosition: position,
          skipBack: skip_back_enable,
          skipForward: skip_forward_enable,
          style,
          adTagUrl,
          analytics: {
            playerName: name,
            videoId: id,
            videoTitle,
            videoTags: tags,
            videoState: state,
            videoType: type,
            videoParentId: parent ? parent?.id : null,
            workspaceId,
            workspaceToken,
            workspaceName,
            workspaceOwner,
            isRecording: !!recording_id,
            isExternal: external_id ? external_id : null,
          },
        };

        return playerProps;
      } catch (error) {
        console.error('Error fetching player data:', error);
      }
    };

    const init = async function(){
      const playerProps = await fetchData();
      window.streamEnginePlayer('player', playerProps);
    }
    init();

  }, []);

  const closeFloat = () => {
    setFloating(false);
    setPlayerPos({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    });
  };

  return (
    <>
      <div
        ref={playerRef}
        className={`relative w-full bg-black overflow-hidden ${
          data.settings.float ? 'pt-16/9' : ''
        }`}
      >
        {item && (
          <>
            <Thumbnail
              className='absolute top-0 left-0 opacity-50 blur-lg'
              item={item}
              settings={data.settings}
            />
            <div className='flex flex-col' style={playerPos}>
              {floating && (
                <div className='flex flex-row-reverse'>
                  <CloseRounded
                    fontSize='medium'
                    className='vf-player-close text-black/70 hover:text-black cursor-pointer'
                    onClick={closeFloat}
                  />
                </div>
              )}
              <div className='overflow-hidden bg-black relative pt-16/9'>
                <Thumbnail
                  className='absolute top-0 left-0 opacity-50 blur-lg'
                  item={item}
                  settings={data.settings}
                />
                <SpinLoader className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px]' />
                {/* <iframe
                            //src={`http://localhost:3002/widget/${data.id}/player/${item.id}`}
                            src={`https://www.videoflow.io/widget/${data.id}/player/${item.id}`}
                            title={item.name}
                            className="absolute top-0 left-0 w-full h-full"
                            allowFullScreen
                        ></iframe> */}
                <div
                  id='player'
                  className='absolute top-0 left-0 w-full h-full'
                ></div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PlayerWidget;
